import classNames from 'classnames';

const Vegetarian = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="20 20 60 60"
    className={classNames('dietary-tag', className)}
  >
    <title>Vegetarian</title>
    <g id="leaf">
      <path
        className="dietary-tag__leaf"
        d="M72.38,22.61c-18.16,13.11-32,8-45.18,21.18C12.86,58.2,24,70.59,24,70.59,34,50.13,59,44.08,59,44.08s-23.2,9.08-29.69,29.54c0,0,17.84,10.23,35.59-9.08C80.8,47.24,72.38,22.61,72.38,22.61Z"
      />
    </g>
  </svg>
);

Vegetarian.propTypes = {
  className: PropTypes.string,
};

Vegetarian.defaultProps = {
  className: '',
};

export default Vegetarian;
